import { print } from "graphql";
import { Client } from "graphql-ws";
import { OrderSubscriptionSummaryFragment } from "./fragments/order-subscription-summary";
import { GetOrderResults, getOrderQueryKey } from "./use-get-order";
import { notifyForDeviceOrderEvent } from "~/libs/realtime";
import { getState } from "~/store";
import { queryClient } from "~/providers/query-provider";
import {
	SubscribeToDeviceOrdersDocument,
	SubscribeToDeviceOrdersSubscription,
} from "~/types/__generated/gql/graphql";

void (
	/* GraphQL */ `
		subscription SubscribeToDeviceOrders {
			subscribeToDeviceOrders {
				type
				id
				payload {
					...OrderSubscriptionSummary
				}
			}
		}
		${OrderSubscriptionSummaryFragment}
	`
);

export const subscribeToDeviceOrders = (client: Client) =>
	client.subscribe<SubscribeToDeviceOrdersSubscription>(
		{ query: print(SubscribeToDeviceOrdersDocument) },
		{
			next: async (result) => {
				const event = result.data?.subscribeToDeviceOrders;
				if (!event?.payload) return;

				notifyForDeviceOrderEvent(event);

				const { orderId, orderRef } = getState();
				const orderQueryKey = getOrderQueryKey(orderId ?? orderRef);
				const currentOrder =
					queryClient.getQueryData<GetOrderResults>(orderQueryKey);
				const matchesCurrentOrder =
					event.payload._id === orderId ||
					event.payload._id === currentOrder?._id;

				if (!matchesCurrentOrder) return;

				await queryClient.invalidateQueries({
					queryKey: orderQueryKey,
					exact: true,
				});
			},
			error: (error) => console.error(error),
			complete: () => undefined,
		},
	);
